import styled from 'styled-components';
import { palette } from 'styled-theme';
import { device } from '@jjj/components';

export const UserTitle = styled('span')`
  font-size: 13px;
  font-weight: 900;
  color: ${palette('grayscale', 0)};
  font-family: Helvetica;
  display: flex;
  align-items: center;

  .user {
    display: none;

    @media ${device.tablet} {
      display: block;
    }
  }
`;

export const IconWrapper = styled('div')`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;

  & i {
    font-size: 10px !important;
  }
`;

export const UserAvatarWrapper = styled.div`
  background-image: url(${props => props.avatar});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 50% !important;
  height: 24px;
  width: 24px;
`;

export const LogoutButton = styled.button`
  margin: 0;
  justify-content: flex-start;
  border-radius: 0;
  border: none;
  cursor: pointer;
  text-align: left;
`;
